<template>
  <div style="width: 20px; height: 20px; border-radius: 100%" :style="colorStyle"></div>
</template>

<script>
export default {
  noExport: true,
  props: ['value'],
  computed: {
    colorStyle() {
      var colors = {
        LOW: 'green',
        MEDIUM: 'yellow',
        HIGH: 'red'
      };
      return { backgroundColor: colors[this.value] };
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisSPCoreRisk'] = this;
  },
}
</script>
